<template>
  <div class="page-projects">
    <div class="columns">
      <div class="column content">
        <p class="title">
          Projects.
        </p>
        <div class="control notification is-danger" v-if="error">
          <button class="delete" @click="error = undefined"></button>
          {{ error }}
        </div>
        <b-table
          :data="tableData"
          :bordered="isBordered"
          :striped="isStriped"
          :narrowed="isNarrowed"
          :checkable="isCheckable"
          :loading="isLoading"
          :mobile-cards="hasMobileCards"
          :paginated="isPaginated"
          :per-page="50"
          :pagination-simple="true"
          default-sort="user.first_name"
          :selected.sync="selected"
          :checked-rows.sync="checkedRows">

          <template slot-scope="props">
            <b-table-column field="id" label="ID" width="40" sortable numeric>
              {{ props.row.id }}
            </b-table-column>

            <b-table-column field="name" label="Name" sortable>
              {{ props.row.name }}
            </b-table-column>

            <b-table-column field="description" label="Description" sortable>
              {{ props.row.description }}
            </b-table-column>

            <b-table-column field="sort" label="Sort" sortable>
                {{ props.row.sort }}
              </span>
            </b-table-column>

            <b-table-column field="status" label="Status" sortable>
              <b-icon
                pack="mdi"
                :icon="props.row.status  ? 'done' : 'close'">
              </b-icon>
            </b-table-column>

            <b-table-column field="edit" label="Edit" sortable>
              <b-icon
                pack="mdi"
                :icon="props.row.status  ? 'done' : 'close'">
              </b-icon>
            </b-table-column>

            <!-- date: {{ new Date(props.row.date).toLocaleDateString() }} -->
          </template>

          <div slot="empty" class="has-text-centered">
            <span style="color:#ccc;">Table contains nothing.</span>
          </div>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import auth from '@/apis/Auth'
export default {
  data () {
    return {
      tableData: [],
      checkedRows: [],
      selected: {},
      isBordered: false,
      isStriped: false,
      isNarrowed: false,
      isCheckable: false,
      isLoading: false,
      hasMobileCards: true,
      isPaginated: true,
      error: undefined
    }
  },
  computed: mapGetters([
    'evenOrOdd',
    'isAuthenticated'
  ]),
  methods: {
    test () {
    },
    ...mapActions([
      'authenticated',
      'unauthenticated'
    ])
  },
  beforeCreate () {
  },
  created () {
    console.log('created Users.vue')

    this.isLoading = true
    auth.projects(this.credentials)
    .then(data => {
      console.log('get projects')
      console.log(data)
      this.tableData = data.data
      this.isLoading = false
    })
    .catch(error => {
      console.log('invalid get projects', error)
      this.error = error.error
      this.isLoading = false
    })
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-projects {
}
</style>



// WEBPACK FOOTER //
// Projects.vue?35b817b0